import React from 'react';

import LoaderComponent from 'coreComponents/LoaderComponent';

const fallback = <LoaderComponent />;

const ResetPassword = suspenseComponent(() => import('../../pages/reset-password'), {fallback});
const SetPassword = suspenseComponent(() => import('../../pages/set-password'), {fallback});
const MyAccount = suspenseComponent(() => import('../../pages/my-account'), {fallback});
const Orders = suspenseComponent(() => import('../../pages/my-account/SubPages/orders'), {fallback});
const Addresses = suspenseComponent(() => import('../../pages/my-account/SubPages/addresses'), {fallback});
const Payments = suspenseComponent(() => import('../../pages/my-account/SubPages/payments'), {fallback});
const NewsletterPreferenceCenter = suspenseComponent(() => import('../../pages/my-account/SubPages/NewsletterPreferenceCenter'), {fallback});
const PersonalData = suspenseComponent(() => import('../../pages/my-account/SubPages/personal-data'), {fallback});
const Wishlist = suspenseComponent(() => import('../../pages/my-account/wishlist'), {fallback});
const ReturnOrder = suspenseComponent(() => import('../../pages/return-order'), {fallback});
const TrackOrder = suspenseComponent(() => import('../../pages/track-order'), {fallback});
const Sitemap = suspenseComponent(() => import('../../pages/sitemap'), {fallback});
const Csc = suspenseComponent(() => import('../../pages/csc'), {fallback});
const APIRouter = suspenseComponent(() => import(/* webpackPrefetch: true */'coreComponents/APIRouter'), {fallback});
const ProductDetail = suspenseComponent(() => import('../../pages/product-detail/ProductDetailRoute'), {fallback});
const StoreLocator = suspenseComponent(() => import('../../pages/store-locator'), {fallback});
const StoreDetail = suspenseComponent(() => import('../../pages/store-detail/StoreDetailRoute'), {fallback});

import {suspenseComponent} from 'coreUtils/adapters/lazy';

import {configureRoutes} from '../../utils/routes-utils';

const routes = [
	{
		path: '/',
		component: APIRouter,
		exact: true,
		prependLocale: false
	},
	{
		path: '/track-order',
		component: TrackOrder,
		exact: true,
	},
	{
		path: '/return',
		component: ReturnOrder,
		exact: true,
	},
	{
		path: '/wishlist',
		component: Wishlist,
		exact: true,
	},
	{
		path: '/myaccount',
		component: MyAccount,
		exact: true,
	},
	{
		path: '/orders',
		component: Orders,
		exact: true,
	},
	{
		path: '/personaldata',
		component: PersonalData,
		exact: true,
	},
	{
		path: '/addresses',
		component: Addresses,
		exact: true,
	},
	{
		path: '/payments',
		component: Payments,
		exact: true,
	},
	{
		path: '/newsletter-preference-center',
		component: NewsletterPreferenceCenter,
		exact: true,
	},
	{
		path: '/stores',
		component: StoreLocator,
		exact: true,
	},
	{
		path: '/store-detail',
		component: StoreDetail,
		exact: true,
	},
	{
		path: '/sitemap',
		component: Sitemap,
		exact: true,
	},
	{
		path: '/reset-password',
		component: ResetPassword,
		exact: true,
	},
	{
		path: '/set-password',
		component: SetPassword,
		exact: true,
	},
	{
		path: '/csc',
		component: Csc,
		exact: true,
	},
	{
		path: '/*.html',
		component: ProductDetail,
		exact: true,
	},
	{
		path: '*',
		component: APIRouter,
	},
];

export default configureRoutes(routes);
